import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Protège une route en fonction du rôle de l'utilisateur connecté.
 * - Redirige vers /login si personne n'est connecté.
 * - Redirige vers /dashboard si l'utilisateur est connecté mais n'a pas
 *   un des rôles autorisés (ex : un simple voyageur qui tape /admin dans l'URL).
 *
 * `allowedRoles` doit correspondre exactement aux rôles acceptés côté back
 * dans config/packages/security.yaml (access_control ^/api/admin).
 */
const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const roles = Array.isArray(user.roles)
    ? user.roles.map(r => (typeof r === "string" ? r : r.authority ?? r.role ?? ""))
    : [];

  const hasAccess = allowedRoles.length === 0 || roles.some(r => allowedRoles.includes(r));

  if (!hasAccess) {
    // Redirige vers SON propre espace plutôt que vers /dashboard (réservé
    // aux voyageurs) - utile par ex. si un agent tape /admin dans l'URL.
    if (roles.includes("ROLE_ADMIN"))      return <Navigate to="/admin" replace />;
    if (roles.includes("ROLE_AGENT"))      return <Navigate to="/agent" replace />;
    if (roles.includes("ROLE_PROGRAMMER")) return <Navigate to="/programmer" replace />;
    if (roles.includes("ROLE_CONTROLLER")) return <Navigate to="/admin/scan" replace />;
    if (roles.includes("ROLE_SUPPORT"))    return <Navigate to="/admin/messages" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleProtectedRoute;
